import React, { createRef, RefObject } from "react";
import styled from "@emotion/styled";

const keyCodes = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  ESCAPE: 27,
  SPACE: 32,
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40,
  LEFT_COMMAND: 91,
  RIGHT_COMMAND: 93,
};

const ignoreKeyCodes = [
  keyCodes.BACKSPACE,
  keyCodes.TAB,
  keyCodes.ENTER,
  keyCodes.SHIFT,
  keyCodes.LEFT_ARROW,
  keyCodes.UP_ARROW,
  keyCodes.RIGHT_ARROW,
  keyCodes.DOWN_ARROW,
  keyCodes.LEFT_COMMAND,
  keyCodes.RIGHT_COMMAND,
];

const Input = styled.input`
  width: 42px;
  height: 42px;
  background: ${(props) => props.theme.colors.snowdrop} 0% 0% no-repeat
    padding-box;
  border: 1px solid #cdd7dc;
  text-align: center;
  margin-right: 5px;

  text-align: center;
  font: normal normal bold 28px/36px Sofia Pro;
  letter-spacing: 0px;
  color: ${(props) => props.theme.colors.charcoal};

  &:last-child {
    margin-right: 0;
  }

  @media ${(props) => props.theme.bp.tabletUp} {
    width: 50px;
    height: 50px;
  }
`;

const formatEvent = (value: string[]) => ({
  target: {
    value,
  },
});

type Props = {
  values: string[];
  onChange: (evt: { target: { value: string[] } }) => void;
};

export function ChallengeCodeInput({ values, onChange }: Props) {
  const refs: RefObject<HTMLInputElement>[] = values.map(() => createRef());

  const onChangeHandler = ({
    target: { name, value },
  }: React.ChangeEvent<HTMLInputElement>) =>
    onChange(
      formatEvent(
        values.map((v: string, index: number) =>
          index === Number(name) ? value : v
        )
      )
    );

  const onKeyUp = (evt: React.KeyboardEvent<HTMLInputElement>) => {
    // Set focus to the next text field
    const index = Number(evt.currentTarget.name);

    if (evt.currentTarget.value && ignoreKeyCodes.indexOf(evt.keyCode) === -1) {
      if (
        index < refs.length - 1 &&
        refs[index + 1] &&
        refs[index + 1].current
      ) {
        // @ts-ignore
        refs[index + 1].current.focus();
        // @ts-ignore
        refs[index + 1].current.select();
        return;
      }
    }

    if (
      evt.currentTarget.value === "" &&
      index !== 0 &&
      evt.keyCode === keyCodes.BACKSPACE &&
      refs[index - 1] &&
      refs[index - 1].current
    ) {
      // @ts-ignore
      refs[index - 1].current.focus();
      // @ts-ignore
      refs[index - 1].current.select();
    }
  };

  return (
    <>
      {values.map((digit, index) => (
        <Input
          key={index}
          ref={refs[index]}
          type="text"
          name={String(index)}
          maxLength={1}
          aria-label={`Enter digit ${index + 1}`}
          onPaste={(e) => {
            onChange(
              formatEvent(
                e.clipboardData
                  .getData("text")
                  .split("")
                  .slice(0, values.length)
              )
            );
          }}
          value={values[index]}
          autoComplete="off"
          onChange={onChangeHandler}
          onKeyUp={onKeyUp}
        />
      ))}
    </>
  );
}
